import { render, staticRenderFns } from "./AgencyCategory.vue?vue&type=template&id=59b0594a&lang=pug"
import script from "./AgencyCategory.vue?vue&type=script&lang=js"
export * from "./AgencyCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports